import { render, staticRenderFns } from "./CarrierInvoices.vue?vue&type=template&id=77dddaca&"
import script from "./CarrierInvoices.vue?vue&type=script&lang=js&"
export * from "./CarrierInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports